import { Component, OnDestroy, OnInit, HostListener, ElementRef, ViewChild } from '@angular/core';
import { DialogComponent, DialogService } from 'ngx-bootstrap-modal';
declare var $: any;

export interface DialogYesNoModel {
  message: any;
  elementId: any;
}

@Component({
  selector: 'app-dialog-yes-no',
  templateUrl: './dialog-yes-no.component.html'
})

export class DialogYesNoComponent extends DialogComponent<DialogYesNoModel, boolean> implements DialogYesNoModel, OnDestroy, OnInit {
  @ViewChild('btnconfirm') btnconfirm: ElementRef;
  @ViewChild('btncancel') btncancel: ElementRef;
  message: any;
  elementId: any;

  constructor(dialogService: DialogService) {
    super(dialogService);
    setTimeout(() => {
      document.getElementById('btnconfirm').focus();
    }, 10);
  }

  /**
   * 初期表示
   * */
  ngOnInit() {
    // 背面の固定
    $('body').css('overflow-y', 'hidden'); // 強化テストNo245
  }

  confirm() {
    this.close(true);
    setTimeout(() => {
      if (document.getElementById(this.elementId) != null) {
        document.getElementById(this.elementId).focus();
      }
    }, 200);
  }

  cancel() {
    this.close(false);
    setTimeout(() => {
      if (document.getElementById(this.elementId) != null) {
        document.getElementById(this.elementId).focus();
      }
    }, 200);
  }

  ngOnDestroy() {
    // 背面の固定解除
    $('body').css('overflow-y', 'scroll'); // 強化テストNo245

    this.close(false);
    setTimeout(() => {
      if (document.getElementById(this.elementId) != null) {
        document.getElementById(this.elementId).focus();
      }
    }, 200);
  }

  @HostListener('window:keydown', ['$event'])
  onKeydown(event: KeyboardEvent) {
    // Tabキーの場合
    if (event.keyCode == 9) {
      if (document.activeElement.id == 'btnconfirm') {
        this.btncancel.nativeElement.focus();
      } else {
        this.btnconfirm.nativeElement.focus();
      }
      return false;
    }
    // 十字キーの場合
    if (event.keyCode == 37 || event.keyCode == 38 || event.keyCode == 39 || event.keyCode == 40) {
      if (document.activeElement.id == 'btnconfirm') {
        this.btncancel.nativeElement.focus();
      } else {
        this.btnconfirm.nativeElement.focus();
      }
      return false;
    }
    // ENTERキーの場合
    if (event.keyCode == 13) {
      if (document.activeElement.id == 'btncancel') {
        this.cancel();
      } else if (document.activeElement.id == 'btnconfirm') {
        this.confirm();
      } else {
        this.cancel();
      }
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/component/dialog-yes-no/dialog-yes-no.component.ts